import React, { useState } from "react";
import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";
import TimeField from "../../components/TimeField";
import { TimeFieldProps } from "../../components/TimeField/TimeField";

const StoryComponent = ({ ...fieldProps }: TimeFieldProps) => {
    const [time, setTime] = useState(100);

    return (
        <VStack gap={0.5} style={{ padding: 10, alignSelf: "stretch" }}>
            <TimeField value={time} {...fieldProps} onChange={setTime} />
        </VStack>
    );
};

const meta = {
    title: "Fields/Time",
    component: StoryComponent,
    argTypes: {
        isDuration: {
            control: {
                type: "boolean",
            },
        },
    },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        isDuration: false,
    },
};
